import PropTypes from 'prop-types';
// -*- mode: jsx;-*-

/**
 * @param supportCategories The categories to list in the select box
 * @param selectedCategory The currently-selected category
 * @param defaultText The text to show in the default option
 * @param updateCategory Callback to invoke when the select box changes
 * @param selectorId CSS ID for the select box
 * @param hasError Whether to visually indicate this field is in an error-state
 * @returns {JSX.Element|null} <code>null</code> if no categories are supplied
 * @constructor
 */
export default function CategorySelector({
    supportCategories, selectedCategory,
    defaultText, updateCategory, selectorId, hasError,
}) {
    if (!supportCategories || supportCategories.length === 0) {
        return null;
    }

    const options = supportCategories.map(
        category => <option className={category.keyword} key={category.id} value={category.id}>{category.description}</option>,
        this);

    return (
        <div className="input-holder">
            {/* eslint-disable-next-line jsx-a11y/no-onchange */}
            <select id={selectorId} className={hasError ? 'hasError' : ''} value={selectedCategory} onChange={updateCategory}>
                <option>{defaultText}</option>
                {options}
            </select>
        </div>
    );
}
CategorySelector.propTypes = {
    supportCategories: PropTypes.array,
    selectedCategory: PropTypes.string,
    defaultText: PropTypes.string.isRequired,
    updateCategory: PropTypes.func.isRequired,
    selectorId: PropTypes.string,
    hasError: PropTypes.bool,
};
